import React from "react";
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { formatCurrency } from "../helpers/formatter";
import { path, pathOr } from "ramda";
import { shareCrmLink } from "../redux/actions/policyAction";
import { useDispatch } from "react-redux";

const PremiumFinancingCard = (props) => {
    const { policy } = props
    const user = pathOr(false, ['user'], props)
    const dispatch = useDispatch();
    const shareLink = () => {
        dispatch(shareCrmLink({policyNumber: policy.policyNumber}))
    }
    return (
        <div style={{ borderRadius: 16, borderWidth: 1, borderColor: '#489135', background: '#EDF6EB', marginTop: 12, borderStyle: 'solid', }}>
            <Grid container columns={{ xs: 4, sm: 8, md: 12 }} spacing={2} style={{ borderWidth: 1, borderColor: '#489135', padding: 30 }}>
                <Grid size={5} spacing={2}>
                    <div>
                        <div style={{ borderLeftWidth: 2, borderBottomWidth: 1, borderLeftStyle: 'solid', borderBottomStyle: 'solid', padding: 4, backgroundColor: '#DCECD8', transform: 'skew(-20deg)', }}>
                            <Typography>Premium Financing</Typography>
                        </div>
                        <Typography variant='caption'>Pay your insurance premium with easy EMI.</Typography>
                    </div>
                </Grid>
                <Grid spacing={2}>
                    <div>
                        <Typography color='#40812F' variant='h5' align='center'>₹ {formatCurrency(pathOr(0, ['loanInfo', 'eligiblePremiumFinance'], policy))}</Typography>
                        <Typography align='center' variant='body2'>Loan amount</Typography>
                    </div>
                </Grid>
                {user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success'>Avail Now</Button>
                        </div>
                    </Grid>
                )}
                {!user && (
                    <Grid>
                        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                            <Button variant='contained' color='success' onClick={() => shareLink()}>Share Link</Button>
                        </div>
                    </Grid>
                )}
            </Grid>
            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} spacing={2} style={{ borderWidth: 1, borderColor: '#489135', backgroundColor: 'white', margin: 0 }}>
                
                <Grid size={6} spacing={2}>
                    <Grid container style={{ paddingTop: 32, paddingBottom: 32 }}>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography variant="caption">Policy due date</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption">12-02-2024</Typography></Grid>

                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography variant="caption">Rate of Interest</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption">{pathOr(0, ['loanInfo', 'interest'], policy)}%</Typography></Grid>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography variant="caption">Processing Fee</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption">₹ {formatCurrency(pathOr(0, ['loanInfo', 'loanProcessingFee'], policy))}</Typography></Grid>
                        {pathOr(0, ['loanInfo', 'upfront'], policy) != 0 && (
                        <>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography variant="caption">Upfront</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption">₹ {formatCurrency(pathOr(0, ['loanInfo', 'upfront'], policy))}</Typography></Grid>
                        </>
                    )}
                    </Grid>
                </Grid>
                <Grid size={6} spacing={2} style={{}}>
                    <Grid container style={{ paddingTop: 32, paddingBottom: 32, backgroundColor: '#f5f5f5', margin: '10px' }}>
                        <Grid size={6} spacing={2}>
                            <Typography align='center' variant="caption" style={{ paddingLeft: 12 }}>EMI Tenure</Typography>
                        </Grid>

                        <Grid size={6} align='center' spacing={2}><Typography variant="caption" style={{ paddingRight: 12 }}>EMI Amount</Typography></Grid>

                        {
                            Object.keys(pathOr([], ['loanInfo', 'emi'], policy)).map((data, index) => {
                                if(data%3===0){
                                    return (
                                        <>
                                            <Grid size={6} spacing={2}>
                                                <Typography align='center' style={{ paddingLeft: 12 }} variant="caption">{data} M</Typography>
                                            </Grid>
                                            <Grid size={6} align='center' spacing={2}><Typography variant="caption" style={{ paddingRight: 12 }}>₹ {formatCurrency(policy.loanInfo.emi[data].emi)}</Typography></Grid>
                                        </>
                                    )
                                }
                                
                            })
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid container columns={{ xs: 4, sm: 6, md: 12 }} spacing={2} style={{ borderWidth: 1, borderColor: '#489135', backgroundColor: '#204018', margin: 0, paddingTop:30, paddingBottom:30, paddingLeft:12, paddingRight:12,borderRadius:'0 0 16px 16px' }}>
                <Grid spacing={2}>
                    <div>
                        <div style={{ borderLeftWidth: 2, borderBottomWidth: 1, borderLeftStyle: 'solid', borderBottomStyle: 'solid', padding: 4, backgroundColor: '#DCECD8', transform: 'skew(-20deg)', }}>
                            <Typography>Overdraft Facility</Typography>
                        </div>
                    </div>
                </Grid>
                <Grid  spacing={2}>
                    <div>
                        <Typography color='#FFF' variant='h5' align='center'>₹  {formatCurrency(pathOr(0, ['loanInfo', 'odLoanAmount'], policy))}</Typography>
                        <Typography color='#FFF' align='center' variant='body2'>Loan amount</Typography>
                    </div>
                </Grid>

                <Grid size={6} spacing={2}>
                    <Grid container style={{}}>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography color="white" variant="caption">Rate of Interest</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption" color="white">{pathOr(0, ['loanInfo', 'interest'], policy)}%</Typography></Grid>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography color="white" variant="caption">Processing Fee</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography color="white" variant="caption">₹ {formatCurrency(pathOr(0, ['loanInfo', 'odProcessingFee'], policy))}</Typography></Grid>
                    </Grid>

                </Grid>
                <Grid size={6} spacing={2}>
                    <Grid container style={{}}>
                        <Grid size={6} spacing={2} style={{ paddingLeft: 12 }}>
                            <Typography color="white" variant="caption">Upfront amount</Typography>
                        </Grid>
                        <Grid size={6} spacing={2}><Typography variant="caption" color="white">₹ {formatCurrency(pathOr(0, ['loanInfo', 'odPayable'], policy))}</Typography></Grid>

                    </Grid>

                </Grid>
                <Grid size={12} spacing={2}>
                    <Typography color="#FAAD14" variant="caption">The upfront amount will be deducted, and the remaining loan amount will be credited to the bank account .</Typography>

                </Grid>

            </Grid>
        </div>
    )
}

export default PremiumFinancingCard